import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

/**
 * @param {{ data: Object, onChange: (next: Object) => void, disabled?: boolean }} props
 */
const EditableOrderHeaderForm = ({ data, onChange, disabled = false }) => {
  const patchOrder = (field, value) => {
    onChange({
      ...data,
      order: { ...data.order, [field]: value },
    });
  };

  const patchTotals = (field, value) => {
    onChange({
      ...data,
      totals: { ...data.totals, [field]: value },
    });
  };

  const field = (label, section, key, className = '', patchFn) => (
    <Form.Group as={Col} md={6} className="mb-2">
      <Form.Label className="small mb-0">{label}</Form.Label>
      <Form.Control
        size="sm"
        disabled={disabled}
        className={className}
        value={data[section]?.[key] ?? ''}
        onChange={e => patchFn(key, e.target.value)}
      />
    </Form.Group>
  );

  const numField = (label, section, key, patchFn) => (
    <Form.Group as={Col} md={4} className="mb-2">
      <Form.Label className="small mb-0">{label}</Form.Label>
      <Form.Control
        size="sm"
        type="number"
        step="any"
        disabled={disabled}
        className="number-value currency-value"
        value={data[section]?.[key] ?? ''}
        onChange={e => {
          const v = e.target.value;
          patchFn(key, v === '' ? null : Number(v));
        }}
      />
    </Form.Group>
  );

  return (
    <div>
      <h6 className="mb-2">Order</h6>
      <Row>
        {field('Order number', 'order', 'orderNumber', 'product-number', (k, v) =>
          patchOrder(k, v)
        )}
        {field('Order date', 'order', 'orderDate', '', (k, v) => patchOrder(k, v))}
        {field('Currency', 'order', 'currency', 'currency-value', (k, v) => patchOrder(k, v))}
        {numField('Total price', 'totals', 'itemsSubtotal', (k, v) => patchTotals(k, v))}
      </Row>
    </div>
  );
};

export default EditableOrderHeaderForm;
